export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";